createStore("products", {
  productsByHandle: {},
  loadingProducts: {},

  getProduct(handle) {
    if (!this.productsByHandle[handle]) this.fetchProduct(handle);
  
    return this.productsByHandle[handle];
  },

  async fetchProduct(handle, cache = false) {
    if (this.productsByHandle[handle] && cache) return this.productsByHandle[handle];
    
    if(!cache) {
      this.loadingProducts[handle] = fetch(`${Shopify.routes.root}products/${handle}?view=json`, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).catch((error) => {
        console.error('Error:', error);
      }).then(r => r.json());
    }

    this.productsByHandle[handle] = Shopify.uscape(await this.loadingProducts[handle]);

    Shopify.SessionStorage.set(handle, JSON.stringify(this.productsByHandle[handle]))

    return this.productsByHandle[handle];
  }
})